import { render, staticRenderFns } from "./viewDetail.vue?vue&type=template&id=f6123042&scoped=true"
import script from "./viewDetail.vue?vue&type=script&lang=js"
export * from "./viewDetail.vue?vue&type=script&lang=js"
import style0 from "./viewDetail.vue?vue&type=style&index=0&id=f6123042&prod&lang=scss"
import style1 from "./viewDetail.vue?vue&type=style&index=1&id=f6123042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6123042",
  null
  
)

export default component.exports